import * as React from 'react'

import classNames from 'classnames/bind'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  description: string
  squared?: boolean
}

export default function EmptyList({ description, squared = false }: Props) {
  return (
    <div
      className={cx('emptyList', {
        squared,
      })}
    >
      {description}
    </div>
  )
}
